import React from "react";
import { Link } from "react-router-dom";
import "../css/paysuccess.css";

const PaySuccess = () => (
  <main className="successDiv">
    <div className="success-container">
      <h1>Payment is not enabled</h1>
      <p>No payment or order has been submitted through this preview website.</p>
      <Link to="/shop">Return to catalogue</Link>
    </div>
  </main>
);

export default PaySuccess;
